import React from 'react'
import { TouchableOpacity, ViewStyle } from 'react-native'
import styled, { useTheme } from 'styled-components/native'

import Typography from 'APP/Converse/Typography'
import Icon from 'APP/Converse/Icon'

export interface BaseBannerProps {
  title: string
  icon: string
  onPress: () => void
  description?: string
  style?: ViewStyle
  testID?: string
  accessibilityLabel?: string
}

const OuterContainer = styled(TouchableOpacity)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.colors.elementsBorder};
`

const InnerContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  align-self: center;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const LeftContent = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`

const IconWrapper = styled.View`
  padding: 0 ${({ theme }) => theme.metrics.baseMargin}px;
`

const TextContainer = styled.View`
  flex: 1;
  gap: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

const Title = styled(Typography).attrs(() => ({
  variant: 'bodySmallBold',
}))`
  color: ${({ theme }) => theme.colors.text};
`

const Description = styled(Typography).attrs(() => ({
  variant: 'bodySmall',
}))`
  color: ${({ theme }) => theme.colors.dim};
`

const MemberTaskBannerBase: React.FC<BaseBannerProps> = ({
  title,
  description,
  icon,
  testID,
  accessibilityLabel,
  style,
  onPress,
}) => {
  const theme = useTheme()

  return (
    <OuterContainer
      style={style}
      testID={testID}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      onPress={onPress}
    >
      <InnerContainer>
        <LeftContent>
          <IconWrapper>
            <Icon
              src={icon}
              size={theme.metrics.icon.small}
              variant="materialIcons"
              color="accent"
            />
          </IconWrapper>
          <TextContainer>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
          </TextContainer>
        </LeftContent>

        <Icon
          src="chevron-right"
          size={theme.metrics.icon.small}
          variant="material"
          color="accent"
          testID={testID ? `${testID}_RIGHT_ICON` : undefined}
        />
      </InnerContainer>
    </OuterContainer>
  )
}

export default MemberTaskBannerBase
